import { baseApi } from "./baseApi";

const BRANCHASSIGNMENT_BASE_URL = "/branchAssignment";

export const branchAssignmentApi = baseApi.injectEndpoints({
  tagTypes: ["BranchAssignment"],

  endpoints: (builder) => ({
    getBranchAssignmentList: builder.query({
      query: (params) => ({
        url: `${BRANCHASSIGNMENT_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
            ...result.data.map(({ _id }) => ({
              type: "BranchAssignment",
              id: _id,
            })),
            { type: "BranchAssignment", id: "LIST" },
          ]
          : [{ type: "BranchAssignment", id: "LIST" }],
    }),
    createBranchAssignment: builder.mutation({
      query: (payload) => ({
        url: `${BRANCHASSIGNMENT_BASE_URL}/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "BranchAssignment", id: "LIST" },
      ],
    }),
    getBranchAssignmentDetail: builder.query({
      query: (id) => `${BRANCHASSIGNMENT_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "BranchAssignment", id },
        { type: "BranchAssignment", id: "LIST" },
      ],
    }),

    updateBranchAssignment: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${BRANCHASSIGNMENT_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "BranchAssignment", _id },
        { type: "BranchAssignment", id: "LIST" },
      ],
    }),
    updateBranchAssignmentStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `${BRANCHASSIGNMENT_BASE_URL}/${id}/status`,

        method: "PUT",
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BranchAssignment", id },
        { type: "BranchAssignment", id: "LIST" },
      ],
    }),
    getDDLUnassignedUserList: builder.query({
      query: (params) => ({
        url: `${BRANCHASSIGNMENT_BASE_URL}/ddl-unassigned-users`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({ type: "User", id })),
            { type: "BranchAssignment", id: "DDL" },
          ]
          : [{ type: "BranchAssignment", id: "DDL" }],
    }),
    getAssignedBranches: builder.query({
      query: () => `${BRANCHASSIGNMENT_BASE_URL}/my-branches`,
      providesTags: ["AssignedBranches"],
    }),
    getAssignedRegions: builder.query({
      query: () => `${BRANCHASSIGNMENT_BASE_URL}/my-regions`,
      providesTags: ["AssignedRegions"],
    }),
  }),
});
export const {
  useGetBranchAssignmentListQuery,
  useLazyGetBranchAssignmentListQuery,
  useCreateBranchAssignmentMutation,
  useGetBranchAssignmentDetailQuery,
  useUpdateBranchAssignmentMutation,
  useUpdateBranchAssignmentStatusMutation,
  useLazyGetDDLUnassignedUserListQuery,
  useGetAssignedBranchesQuery,
  useGetAssignedRegionsQuery,
} = branchAssignmentApi;
